/** @jsx jsx */
import { jsx, Card, Text } from 'theme-ui';
import { Stack } from 'raam'

const SponsorName = ({children}) => {

  const styleSX = {
    fontSize: 8,
    fontFamily: 'light',
    textAlign: 'center'
  }

  return (
    <Text sx={styleSX}>{children}</Text>
  )
}

const Sponsor = (props) => {

  const paddingSX = {
    padding: 4
  }

  const titleSX = {
    textAlign: 'center',
    borderBottom: '1px solid',
    borderColor: 'greyborder'
  }

  return (
    <Card variant="slim">
      <Text sx={{...titleSX, ...paddingSX}}>Sponsored by</Text>
      <Stack sx={paddingSX}>
        {props.children}
      </Stack>
    </Card>
  )
}



export default Sponsor
export { SponsorName }
